const getOperatorBreaksResponse = (response) => {
  return {
    ...response?.data,
    dataSource: response?.data?.breaksReport,
  };
};

export default getOperatorBreaksResponse;
